import { CONFIG_ENVIRONMENT, CONFIG_SENTRY_DSN, CONFIG_VERSION } from '../../config';
import { LogAppender } from './logger';
import * as Sentry from '@sentry/browser';

/* eslint-disable @typescript-eslint/no-explicit-any */

export function initSentry(): void {
  try {
    Sentry.init({
      dsn: CONFIG_SENTRY_DSN,
      environment: CONFIG_ENVIRONMENT,
      release: CONFIG_VERSION,
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      debug: CONFIG_ENVIRONMENT !== 'PRODUCTION' ? true : false,
      ignoreErrors: [
        'extension', // Extensions in General
        'moz-extension', // General Firefox Extensions
        'mailvelope-client-api.js', // Anoying Mailvelope Extension
        'BetterJsPop', // https://github.com/nicolauns/BetterJsPop
        'grecaptcha', // Google Recaptcha
        'grecaptcha is not defined', // Google Recaptcha
        'googletag', // Google Tag (Advertising)
        'navigator.geolocation', // Something which want's to access the users device location
        'Cannot redefine property: play', // Something media (video) related
        'Cannot redefine property: FuckAdBlock', // Some AdBlock Detection Script
        'Cannot redefine property: BlockAdBlock', // Some AdBlock Detection Script
        'Cannot redefine property: googletag', // Google Tag (Advertising)
        'can\'t redefine non-configurable property "fuckAdBlock"', // Some AdBlock Detection Script
        'redeclaration of const hideMyLocation' // Whatever this is?
      ]
    });
  } catch (ex) {
    console.error(ex);
  }
}

export function stringify(args: any[]): string {
  return args.map((item) => `${item instanceof Error ? item.toString() : JSON.stringify(item)}`).join(' ');
}

export const sentryAppender: LogAppender = {
  warn: (...args) => {
    /* istanbul ignore next else */
    if (Sentry && typeof Sentry.captureMessage === 'function') {
      Sentry.captureMessage(stringify(args), Sentry.Severity.Warning);
    }
  },
  error: (...args) => {
    /* istanbul ignore next else */
    if (Sentry && typeof Sentry.captureMessage === 'function') {
      Sentry.captureMessage(stringify(args), Sentry.Severity.Error);
    }
  }
};
